export default "__VITE_ASSET__ktmSCI1g__"